import { NativeSharedStorage } from '../../native/shared'
import Cookies from '../utils/cookies'

export const SESSION_CONTEXT_KEY = 'lobbyze.session_context'

export type SessionContext = {
  userId: string | null
  tierId: number | null
  epoch: number
  loggedIn: boolean
}

function parseTierId(raw: string | undefined | null): number | null {
  if (raw == null || raw === '') {
    return null
  }
  const n = parseInt(String(raw), 10)
  return Number.isFinite(n) ? n : null
}

function readCurrent(): SessionContext | null {
  try {
    const raw = localStorage.getItem(SESSION_CONTEXT_KEY)
    if (!raw) {
      return null
    }
    return JSON.parse(raw) as SessionContext
  } catch {
    return null
  }
}

/**
 * Publish the shared session bus for notification-cards (and same-origin web).
 * Always bumps epoch. Never stores JWTs.
 */
export function publishSessionContext(partial: Partial<SessionContext> = {}): void {
  const current = readCurrent()
  const next: SessionContext = {
    userId: partial.userId !== undefined ? partial.userId : (current?.userId ?? null),
    tierId: partial.tierId !== undefined ? partial.tierId : parseTierId(Cookies.get('tier')),
    epoch: Date.now(),
    loggedIn: partial.loggedIn !== undefined ? partial.loggedIn : (current?.loggedIn ?? false),
  }
  const json = JSON.stringify(next)
  localStorage.setItem(SESSION_CONTEXT_KEY, json)
  NativeSharedStorage.setItem(SESSION_CONTEXT_KEY, json)
}
